import React from 'react';
import { Link } from 'react-router-dom';
import Chart from 'react-google-charts';
import { isBrowser } from 'react-device-detect';
import Card from '../../Cards';
import './VisitsChart.scss';
import Moment from 'moment';
import 'moment/locale/es';
import { extendMoment } from 'moment-range';
import {countBy, getChartData} from '../../Analytics/containers/DatesAnalytics';


const moment = extendMoment(Moment);

moment.locale('es');
let startDate = moment().startOf('isoWeek').format('D');
let endDate = moment().endOf('isoWeek').format('D [de] MMMM [del] YYYY');
let dateByWeek = `Del ${startDate} al ${endDate}`;

let weekStart = moment().startOf('week');
let weekDays = [];
//let weekDays2 = [];
for (let i = 0; i <= 6; i++) {
  weekDays.push(moment(weekStart).add(i, 'days').format('dddd D'));
  //weekDays2.push(moment(weekStart).add(i, 'days').format('dd D').toUpperCase());
}


const VisitsChart = props => {
  
  const analyticsViewProfile = props.authClient.analyticsViewProfile;
  const countViews = props.authClient.analyticsViewProfile && props.authClient.analyticsViewProfile.filter(item => moment.unix(item.createdAt.seconds).isBetween(moment().startOf('week'), moment().endOf('week'))).length;
  const data = analyticsViewProfile && getChartData(analyticsViewProfile, 'views', 'week');
  return (
    <div
      className={
        isBrowser ? 'home-card card-chart-browser' : 'home-card card-chart'
      }
    >
      <div className="card-chart-content">
        <Link to="/dashboard/analytics" className="link">
          Ver más
        </Link>
        <Card
              title="Visitas a tu perfil"
              subtitle1={dateByWeek}
              subtitle2={`${countViews} visitas`}
            //filter={true}
            >
             
        <div className="home-chart-wrapper">
          <div className="home-chart-component">
            <Chart
              width={'100%'}
              height={'100%'}
              chartType="ColumnChart"
              loader={<div style={{marginBottom:16}}>Cargando gráfica...</div>}
             data={data? 
              data : 
              [['Dia', 'Visitas', { role: 'style' }],
              [weekDays[0], 0, '#35b9b6'],
              [weekDays[1], 0, '#106c9d'],
              [weekDays[2], 0, '#35b9b6'],
              [weekDays[3], 0, '#106c9d'],
              [weekDays[4], 0, '#35b9b6'],
              [weekDays[5], 0, '#106c9d'],
              [weekDays[6], 0, '#35b9b6'],
            ]}
              options={{
                // Material design options
                maxWidth: '100%',
                height: 300,
                chartArea: {
                  width: '80%',
                },
                
                legend: { position: 'none' },
                hAxis: {
                  textStyle: {
                    fontName: 'Lato',
                    bold: true,
                    color: '#10587f',
                    fontSize: 9,
                  },
                  baseline: {
                    color: '#e7e7e7',
                  },
                  //ticks: [5,10,15,20],
                  viewWindowMode: 'pretty'
                  
                },
                vAxis: {
                  minValue: 10,
                  textStyle: {
                    fontName: 'Lato',
                    bold: true,
                    color: '#10587f',
                    fontSize: 10,
                  },
                  gridlines: {
                    color: '#e7e7e7',

                  },
                  minorGridlines: {
                    color: '#e7e7e7',
                  },
                  baseline: {
                    color: '#e7e7e7',
                  },
                  format: '#'
                },
                bar: { groupWidth: '50%' },
              }}
              // For tests
              rootProps={{ 'data-testid': '0' }}
            />
          </div>
          <div className="home-chart-legend">
            <ul className="subtitle-12">
              <li>LU | {data && data[1][1]}</li>
              <li>MA | {data && data[2][1]}</li>
              <li>MI | {data && data[3][1]}</li>
              <li>JU | {data && data[4][1]}</li>
              <li>VI | {data && data[5][1]}</li>
              <li>SÁ | {data && data[6][1]}</li>
              <li>DO | {data && data[7][1]}</li>
            </ul>
          </div>
        </div>
        </Card>
      </div>
      </div>
  );
};

export default VisitsChart;
